import React, {useState} from "react";

const DetailsSection = ({ tab,details, translations, selectedDetails, selectedDate, setSelectedDetails }) => {
    const [allCheckValue, setAllCheckValue] = useState(true);

    return (
        <>
            <h5 className="s-page__details-title">
                { tab === 1 ? translations?.['project_reports.index.titles.details'] :
                    tab === 2 ? translations?.['quarterly_reports.index.titles.details'] :
                        translations?.['procurement_reports.index.titles.details']
                }
            </h5>
            {
                selectedDate && details ? (
                    <div className="s-page__details">
                        <div className="contact__modal-projectBox">
                            <div className="contact__modal-checkbox">
                                <div className="a-checkbox">
                                    <input
                                        id="all"
                                        key="all"
                                        type="checkbox"
                                        checked={allCheckValue}
                                        onClick={(e) => {
                                            if (e?.target?.checked) {
                                                setSelectedDetails(
                                                    details
                                                        ?.map((el) => ({
                                                            ...el,
                                                            [el?.label?.split(" ").join("_").toLowerCase()]: 1,
                                                            show: 1,
                                                        }))
                                                );
                                            } else {
                                                setSelectedDetails(
                                                    details
                                                        ?.map((el) => ({
                                                            ...el,
                                                            [el?.label?.split(" ").join("_").toLowerCase()]: 0,
                                                            show: 0,
                                                        }))
                                                );
                                            }
                                            setAllCheckValue(e?.target?.checked)
                                        }}
                                    />
                                    <label htmlFor="all">
                                        {tab === 1
                                            ? translations?.[
                                                "project_reports.index.actions.select_all_sections"
                                                ]
                                            : translations?.[
                                                "quarterly_reports.index.actions.select_all_sections"
                                                ]}
                                    </label>
                                </div>

                            </div>
                        </div>

                        {details?.map((el) => {
                            if (el?.value !== "id"){

                                return (
                                    <div
                                        key={el?.value}
                                        className={`${
                                            el?.show
                                                ? "contact__modal-projectBox"
                                                : "contact__modal-projectBox disabled"
                                        }`}
                                    >
                                        <div className="contact__modal-checkbox">
                                            <div className="a-checkbox">
                                                {el?.show ? (
                                                    <input
                                                        key={selectedDetails}
                                                        id={el?.value}
                                                        type="checkbox"
                                                        checked={
                                                            selectedDetails?.some(
                                                                (item) => item?.show === 1 && item?.label === el?.label
                                                            )
                                                        }
                                                        onChange={(e) => {
                                                            if (e?.target?.checked) {
                                                                setSelectedDetails((old) =>
                                                                    old.map((item) =>
                                                                        item?.label === el?.label
                                                                            ? {
                                                                                ...item,
                                                                                [el?.label?.split(" ").join("_").toLowerCase()]: 1,
                                                                                show: 1,
                                                                                value: el?.value,
                                                                            }
                                                                            : item
                                                                    )
                                                                );
                                                            } else {
                                                                setSelectedDetails((old) =>
                                                                    old.map((item) =>
                                                                        item?.label === el?.label
                                                                            ? {
                                                                                ...item,
                                                                                [el?.label?.split(" ").join("_").toLowerCase()]: 0,
                                                                                show: 0,
                                                                                value: el?.value,
                                                                            }
                                                                            : item
                                                                    )
                                                                );
                                                            }
                                                        }}
                                                    />
                                                ) : (
                                                    <img src="./../../../public/assets/icons/slash.svg" alt=""/>
                                                )}
                                                <label
                                                    style={{textTransform: "capitalize"}}
                                                    htmlFor={el?.value}
                                                >
                                                    {el?.label}
                                                </label>
                                                <div className="not-show">
                                                    {tab === 1
                                                        ? translations?.[
                                                            "project_reports.index.titles.this_section_is_not_included_in_this_project"
                                                            ]
                                                        : translations?.[
                                                            "quarterly_reports.index.titles.this_section_is_not_included_in_this_report"
                                                            ]}
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                )
                            }

                        })}
                    </div>
                ) : (
                    <div
                        style={{
                            background: "white",
                            padding: "36px 0",
                            marginBottom: 20,
                            border: "1px solid rgba(0,0,0, 0.1)",
                        }}
                    >
                        <div className="plannedProject__placeholder">
                            <img src="/assets/icons/chart-placeholder.png" alt=""/>
                            {tab === 1
                                ? translations?.['project_reports.index.titles.please_select_project_and_date']
                                : tab === 2
                                    ? translations?.['quarterly_reports.index.titles.please_select_project_and_date']
                                    : tab === 3
                                        ? translations?.['procurement_reports.index.titles.please_select_the_package_and_date']
                                        : ''
                            }
                        </div>
                    </div>
                )
            }
        </>

    )
}

export default DetailsSection;
